export default __webpack_public_path__ + "static/media/torso-mid-back.97f8bf35.png";